import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, LOGS_ASSESSMENT_STUDENT_LIST } from '../constants/actionTypes'

const selector = (state: RootState) => prop(GLOBAL_STATE, state)

export const logsAssessmentStudentListSelector = createSelector(selector, data => data[LOGS_ASSESSMENT_STUDENT_LIST])
